import HorizontalDivider from 'global/components/Divider/HorizontalDivider'
import Grid from 'global/components/ui/Grid'
import { FileCheckIcon } from 'lucide-react'
import {
    AutocompleteDescricaoAbono,
    FormFieldJustificativaAbono,
} from 'templates/ManutencaoDoPonto/Digitacao/forms/NovoAbono'
import type { AcaoUi } from './acao-ui'

function ParametrosLancarAbono() {
    return (
        <>
            <Grid item xs={12}>
                <HorizontalDivider className="my-4 select-none">
                    Motivos do abono (preencha pelo menos um campo)
                </HorizontalDivider>
            </Grid>
            <Grid item xs={12}>
                <AutocompleteDescricaoAbono name="parametros.descricao" />
            </Grid>
            <Grid item xs={12}>
                <FormFieldJustificativaAbono name="parametros.justificativa" />
            </Grid>
        </>
    )
}

export const lancarAbono: AcaoUi = {
    icone: FileCheckIcon,
    parametrosIniciais: {},
    Parametros: ParametrosLancarAbono,
}
